import {
  DISABLE_USER_FAILED,
  DISABLE_USER_SUCCESS,
  ENABLED_USER_FAILED,
  ENABLED_USER_SUCCESS,
  FAILED,
  SUCCESS,
} from '@App/app/configs/toastr-events.config';
import {
  SUCCESS_TOASTR_CONFIG,
  WARNING_TOASTR_CONFIG,
} from '@App/app/configs/toastr-messages.config';
import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { UsersHttpService } from '@App/app/pages/users/users-http.service';
import {
  disableUser,
  disableUserFailed,
  disableUserSuccess,
  enableUser,
  enableUserFailed,
  enableUserSuccess,
} from '../actions/users.actions';

@Injectable()
export class UserStatusEffects {
  constructor(
    private actions: Actions,
    private usersHttpService: UsersHttpService,
    private toastrService: NbToastrService,
  ) {}

  disableUser = createEffect(() => {
    return this.createStatusEffect(
      disableUser,
      (userId) => this.usersHttpService.disableUser(userId),
      disableUserSuccess,
      disableUserFailed,
    );
  });

  enableUser = createEffect(() => {
    return this.createStatusEffect(
      enableUser,
      (userId) => this.usersHttpService.enableUser(userId),
      enableUserSuccess,
      enableUserFailed,
    );
  });

  disableUserSuccess = createEffect(
    () => {
      return this.createToastrEffect(
        disableUserSuccess,
        DISABLE_USER_SUCCESS,
        SUCCESS,
        SUCCESS_TOASTR_CONFIG,
      );
    },
    { dispatch: false },
  );

  enableUserSuccess = createEffect(
    () => {
      return this.createToastrEffect(
        enableUserSuccess,
        ENABLED_USER_SUCCESS,
        SUCCESS,
        SUCCESS_TOASTR_CONFIG,
      );
    },
    { dispatch: false },
  );

  disableUserFailed = createEffect(
    () => {
      return this.createToastrEffect(
        disableUserFailed,
        DISABLE_USER_FAILED,
        FAILED,
        WARNING_TOASTR_CONFIG,
      );
    },
    { dispatch: false },
  );

  enableUserFailed = createEffect(
    () => {
      return this.createToastrEffect(
        enableUserFailed,
        ENABLED_USER_FAILED,
        FAILED,
        WARNING_TOASTR_CONFIG,
      );
    },
    { dispatch: false },
  );

  private createStatusEffect(
    action: typeof disableUser | typeof enableUser,
    httpMethod: (userId: number) => ReturnType<UsersHttpService['disableUser']>,
    successAction: typeof disableUserSuccess | typeof enableUserSuccess,
    failedAction: typeof disableUserFailed | typeof enableUserFailed,
  ) {
    return this.actions.pipe(
      ofType(action),
      mergeMap(({ userId }) => {
        return httpMethod(userId).pipe(
          map(() => successAction({ id: userId })),
          catchError(() => of(failedAction())),
        );
      }),
    );
  }

  private createToastrEffect(
    action:
      | typeof disableUserSuccess
      | typeof enableUserSuccess
      | typeof disableUserFailed
      | typeof enableUserFailed,
    message: string,
    title: string,
    config: typeof SUCCESS_TOASTR_CONFIG,
  ) {
    return this.actions.pipe(
      ofType(action),
      tap(() => {
        this.toastrService.show(message, title, { ...config });
      }),
    );
  }
}
